import {useCallback, useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import {isNumeric} from "./tools";

const useListContext = (getList) => {
    const [searchParams, setSearchParams] = useSearchParams();

    const [listState, setListState] = useState({
        list: [],
        loading: false,
        pageNumber: 1,
        pageLimit: 10,
        searchQuery: "",
        countAll: 0,
    })
    const handleUpdateListState = (key, value) => {
        setListState(prev => ({...prev, [key]: value}));


    }

    function setQueryParameter() {
        const params = new URLSearchParams(searchParams);
        params.set("number", listState.pageNumber);
        if (listState.pageLimit !== 10) {
            params.set("limit", listState.pageLimit);
        }
        if (listState.searchQuery !== "") {
            params.set("search", listState.searchQuery);
        } else if (listState.searchQuery === "") {
            params.delete("search");

        }

        setSearchParams(params);

    }

    function getQueryParameter() {
        const params = new URLSearchParams(searchParams);

        return {
            search: params.get('search') || '',
            number: parseInt(params.get('number')) || 1,
            limit: parseInt(params.get('limit')) || 10
        };
    }

    useEffect(() => {
        const {search, number, limit} = getQueryParameter();
        if (search !== listState.searchQuery ||
            number !== listState.pageNumber ||
            limit !== listState.pageLimit
        ) {

            setListState(prev => ({
                ...prev,
                searchQuery: search,
                pageNumber: (number !== 1 && search) ? 1 : number,
                pageLimit: limit
            }));
        }
    }, [searchParams]);

    const onDevicePerPageChange = async (value) => {

        handleUpdateListState("pageNumber", 1)
        handleUpdateListState("pageLimit", value)

    }
    const changePage = async ({selected}) => {
        handleUpdateListState("pageNumber", selected + 1)

    };

    const onSearchBtnClick = async (value) => {
        handleUpdateListState("pageNumber", 1)
        handleUpdateListState("searchQuery", value)
        // handleUpdateListState("pageLimit", 10)

    };

    useEffect(() => {

        setQueryParameter()
        getList();

    }, [listState.pageNumber, listState.searchQuery, listState.pageLimit]);


    return {
        handleUpdateListState,
        listState,
        onDevicePerPageChange,
        changePage,
        onSearchBtnClick,
    }
}
export default useListContext;